// Shared helpers for the store dashboard v2 components.
export const fmtMoney = (v) =>
  "$" + Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = String(t).split(":");
  const hh = parseInt(h, 10);
  if (isNaN(hh)) return t;
  const ampm = hh >= 12 ? "PM" : "AM";
  return `${((hh + 11) % 12) + 1}:${m || "00"} ${ampm}`;
};

export const timeAgo = (ts) => {
  if (!ts) return "";
  const d = new Date(String(ts));
  if (isNaN(d)) return "";
  const s = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const STATUS_STYLES = {
  scheduled: "bg-blue-500/10 text-blue-500",
  pending: "bg-gray-500/10 text-gray-500",
  in_progress: "bg-amber-500/10 text-amber-600",
  deposit_collected: "bg-teal-500/10 text-teal-600",
  completed: "bg-emerald-500/10 text-emerald-600",
  completed_pending_payment: "bg-orange-500/10 text-orange-500",
  cancelled: "bg-red-500/10 text-red-500",
};

export const statusLabel = (s) => (s || "").replace(/_/g, " ");

export const getAuthConfig = () => {
  const token = localStorage.getItem("token");
  return { headers: token ? { Authorization: `Bearer ${token}` } : {} };
};

export const SectionCard = ({ title, icon: Icon, action, children, testid, className = "" }) => (
  <div className={`rounded-xl border border-border bg-card/60 backdrop-blur-sm ${className}`} data-testid={testid}>
    {(title || action) && (
      <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1.5 px-4 pt-3.5 pb-2">
        <h2 className="text-sm font-semibold text-foreground font-['Manrope'] flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4 text-blue-500" />} {title}
        </h2>
        {action}
      </div>
    )}
    <div className="px-4 pb-4">{children}</div>
  </div>
);

export const SectionError = ({ label, onRetry }) => (
  <div className="text-center py-6">
    <p className="text-sm text-muted-foreground mb-2">Unable to load {label}</p>
    {onRetry && (
      <button onClick={onRetry} className="text-xs text-blue-500 hover:underline">Retry</button>
    )}
  </div>
);
